import React, { FC } from 'react';
// mui components
import { Dialog, Grid, Typography, IconButton, DialogProps, SxProps } from '@mui/material';
// icons
import ArrowLeft from 'assets/icons/buttons/arrow-left.svg';
import CloseIcon from '@mui/icons-material/Close';
// styles
import { getStyles } from '../styles';

interface IProps extends DialogProps {
  open: boolean;
  title: string;
  subtitle?: string;
  withBackBtn?: boolean;
  withCloseIconBtn?: boolean;
  handleBack?: () => void;
  handleClose: () => void;
  className?: string;
  customMaxWidth?: string;
  childrenContainerStyles?: SxProps;
  children: React.ReactNode;
}

const CustomDialog: FC<IProps> = ({
  open,
  handleClose,
  title,
  subtitle,
  withBackBtn,
  withCloseIconBtn,
  handleBack,
  className = '',
  customMaxWidth,
  childrenContainerStyles = {},
  children,
  ...rest
}) => {
  const styles = getStyles({
    maxWidth: customMaxWidth,
  });

  return (
    <Dialog open={open} onClose={handleClose} sx={styles.dialog} className={className} {...rest}>
      <Grid sx={styles.dialogTitleWrapper}>
        {withBackBtn ? (
          <IconButton
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              marginBottom: '20px',
              padding: '0',
            }}
            onClick={handleBack}
          >
            <ArrowLeft />
          </IconButton>
        ) : null}
        <Typography sx={styles.dialogTitle}>{title}</Typography>
        {withCloseIconBtn && (
          <IconButton sx={styles.closeIconBtn} onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        )}
        {subtitle && <Typography sx={styles.dialogSubtitle}>{subtitle}</Typography>}
      </Grid>
      <Grid
        sx={
          {
            ...styles.dialogContent,
            ...childrenContainerStyles,
          } as SxProps
        }
      >
        {children}
      </Grid>
    </Dialog>
  );
};

export default CustomDialog;
